const TOAST_CONTAINER_ID = 'winalist-toast-container';
const DEFAULT_DURATION = 4000;
const EXIT_ANIMATION_DURATION = 250;

class Toast {
  static success(message, duration = DEFAULT_DURATION) {
    return this.show('success', message, duration);
  }

  static neutral(message, duration = DEFAULT_DURATION) {
    return this.show('neutral', message, duration);
  }

  static error(message, duration = DEFAULT_DURATION) {
    return this.show('error', message, duration);
  }

  static warning(message, duration = DEFAULT_DURATION) {
    return this.show('warning', message, duration);
  }

  static show(type, message, duration = DEFAULT_DURATION) {
    const toastType = ['success', 'neutral', 'error', 'warning'].includes(type) ? type : 'neutral';
    const toast = document.createElement('div');
    const content = document.createElement('span');

    toast.classList.add('winalist-toast', `winalist-toast--${toastType}`);
    toast.setAttribute('role', ['error', 'warning'].includes(toastType) ? 'alert' : 'status');
    toast.setAttribute('aria-atomic', 'true');

    if (toastType !== 'neutral') {
      toast.appendChild(this.createIcon(toastType));
    }

    content.classList.add('winalist-toast__content');
    content.textContent = message == null ? '' : String(message);
    toast.appendChild(content);
    toast.addEventListener('click', () => this.dismiss(toast));

    this.getContainer().appendChild(toast);

    window.requestAnimationFrame(() => {
      toast.classList.add('winalist-toast--visible');
    });

    const timeout = Number.isFinite(duration) && duration >= 0 ? duration : DEFAULT_DURATION;
    if (timeout > 0) {
      window.setTimeout(() => this.dismiss(toast), timeout);
    }

    return toast;
  }

  static dismiss(toast) {
    if (!toast || !toast.parentNode || toast.classList.contains('winalist-toast--leaving')) {
      return;
    }

    toast.classList.add('winalist-toast--leaving');
    toast.classList.remove('winalist-toast--visible');

    const removeToast = () => {
      const container = toast.parentNode;
      toast.remove();

      if (container && !container.hasChildNodes()) {
        container.remove();
      }
    };

    toast.addEventListener('transitionend', removeToast, { once: true });
    window.setTimeout(removeToast, EXIT_ANIMATION_DURATION);
  }

  static getContainer() {
    let container = document.getElementById(TOAST_CONTAINER_ID);

    if (!container) {
      container = document.createElement('div');
      container.id = TOAST_CONTAINER_ID;
      container.classList.add('winalist-toast-container');
      (document.body || document.documentElement).appendChild(container);
    }

    return container;
  }

  static createIcon(type) {
    const svgNamespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(svgNamespace, 'svg');
    const path = document.createElementNS(svgNamespace, 'path');

    svg.classList.add('winalist-toast__icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', type === 'warning' ? '1.75' : '2.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const iconPaths = {
      success: 'M5 12.5l4.5 4.5L19 7.5',
      error: 'M7 7l10 10M17 7L7 17',
      warning: 'M12 2.5L1.75 21h20.5L12 2.5z M12 8.25v5.5 M12 17.5h.01'
    };

    path.setAttribute('d', iconPaths[type]);
    svg.appendChild(path);

    return svg;
  }
}

export default Toast;
